

$(function () {
	const ua = navigator.userAgent;
	if (ua.indexOf('Trident') !== -1) {
		//IE 11のときの挙動をここに書く
	} else {
		window.WebFontConfig = {
			google: { families: ['Roboto:wght@400;700&display=swap', 'Noto+Serif+JP:400,700&display=swap&subset=japanese'] },
			active: function () {
				sessionStorage.fonts = true;
			}
		};

		(function () {
			var wf = document.createElement('script');
			wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
			wf.type = 'text/javascript';
			wf.async = 'true';
			var s = document.getElementsByTagName('script')[0];
			s.parentNode.insertBefore(wf, s);
		})();
	}
});
